import { render } from "./FooterView.vue?vue&type=template&id=4bee7f64&ts=true"
import script from "./FooterView.vue?vue&type=script&lang=ts"
export * from "./FooterView.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Working\\Projects\\EcosystemPlus\\src\\Web\\Ecosystem.EInvoice.Web\\Themes\\EInvoice\\Mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__